import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/scratch/57173327f5eb/bitsukuk-main/src/app/landing/page.tsx");
